import { apiConstants } from './shared/config';

const routes = [
    {
        path: `/${apiConstants.code}/${apiConstants.codeOs}/:appCode/home/:slug?`,
        name: `${apiConstants.code}.${apiConstants.codeOs}.home`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "app-homeos" */ './views/HomeOs.vue'),
        meta: {
            title: 'Home',
            auth: undefined,
        },
    },
    {
        path: `/${apiConstants.code}/${apiConstants.codeMap}/:appCode/home`,
        name: `${apiConstants.code}.${apiConstants.codeMap}.home`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "app-homemap" */ './views/HomeMap.vue'),
        meta: {
            title: 'Home',
            auth: undefined,
        },
    },
];

export default routes;